import { FC, useEffect } from 'react';
import { Form } from '@/components/ui/form';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import useProjectStore from '../../store/useProjectStore';
import { Actions } from './actions';
import { Infos } from './info';
import { LandExprired } from './land-exprired/LandExprired';

export const ProjectSingle: FC = () => {
  const form = useForm();
  const { id } = useParams();
  const {
    allContour,
    projectsById,
    projectsByIdLoading,
    fetchProjectById,
    fetchProjectAllContour,
  } = useProjectStore();

  useEffect(() => {
    if (id) {
      fetchProjectById({ id });
      fetchProjectAllContour({ id });
    }
  }, [id]);

  return (
    <Form {...form}>
      {projectsById ? (
        <div className="p-10 h-full flex flex-col gap-[29px]">
          <Actions
            regnum={projectsById?.regnum}
            isLoading={projectsByIdLoading}
            idDeleteProject={projectsById?.id}
          />
          <Infos items={projectsById} isLoading={projectsByIdLoading} />
          <hr />
          <div className="flex flex-col gap-4">
            {allContour?.map((el, i) => (
              <LandExprired item={el} index={allContour?.length} key={i} />
            ))}
          </div>
        </div>
      ) : null}
    </Form>
  );
};
